module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "text-white pt-4 px-4",
    attrs: {
      "icon": "user"
    }
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('span', [_vm._v("Mon profil")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "px-4 pb-6",
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('button', {
    staticClass: "bg-white transition px-4 py-2 rounded-lg text-alert text-sm font-medium uppercase",
    attrs: {
      "id": "main-action"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                Déconnexion\n            ")])]), _vm._v(" "), _c('section', {
    staticClass: "relative px-8 pb-15"
  }, [_c('div', {
    staticClass: "flex flex-col md:flex-row items-center md:justify-between"
  }, [_c('div', {
    staticClass: "order-1 md:order-2 mb-4 md:mb-0"
  }, [_c('div', {
    staticClass: "w-16 h-16 md:w-20 md:h-20 rounded-full bg-center bg-cover mx-auto border-2 border-white/60 shadow",
    style: ({
      backgroundImage: ("url(" + _vm.photoProfil + ")")
    }),
    attrs: {
      "id": "profil_client_avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-2 md:order-1"
  }, [_c('h2', {
    staticClass: "font-bold text-gris-bleu mb-2 text-3xl text-center md:text-left",
    attrs: {
      "id": "profil_client_name"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user.first_name) + " "), _c('strong', {
    staticClass: "font-extrabold"
  }, [_vm._v(_vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('p', {
    staticClass: "text-md md:text-xl text-white mb-2 text-center md:text-left",
    attrs: {
      "id": "profil_client_role"
    }
  }, [_vm._v("\n                        Technicien\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-[70%] mx-auto md:mx-0 text-center md:text-left mb-12"
  }, [_c('div', {
    staticClass: "inline-flex items-center gap-2 px-2 py-1 rounded-xl bg-secondary text-white text-md font-medium"
  }, [_c('span', {
    staticClass: "font-normal"
  }, [_vm._v("ID")]), _vm._v(" "), _c('span', {
    staticClass: "font-bold",
    attrs: {
      "id": "profil_client_id"
    }
  }, [_vm._v(_vm._s(_vm.paddedOperatorId) + " " + _vm._s(_vm.user.id))])])])])], 1), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', {
    staticClass: "space-y-3"
  }, [_c('p', {
    staticClass: "flex items-center text-md md:text-xl"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arobase bg-secondary mr-3"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "profil_client_email"
    }
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('p', {
    staticClass: "flex items-center text-md md:text-xl"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-phone bg-secondary mr-3"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "profil_client_phone"
    }
  }, [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.type !== 'magasinier'),
      expression: "user.type !== 'magasinier'"
    }],
    staticClass: "flex items-center text-md md:text-xl",
    attrs: {
      "id": "display_immat_info"
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-car bg-secondary mr-3"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "profil_client_matricule"
    }
  }, [_vm._v(_vm._s(_vm.user.immatriculation))])]), _vm._v(" "), _c('p', {
    staticClass: "flex items-center text-md md:text-xl"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-sign bg-secondary mr-3"
  }), _vm._v(" "), _c('img', {
    staticClass: "h-12",
    attrs: {
      "src": _vm.user.signature64 || '',
      "alt": "Signature",
      "id": "profil_client_signature"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "inline-flex items-center px-4 py-2 bg-primary text-white font-semibold rounded-lg shadow text-md",
    attrs: {
      "id": "edit-profil",
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showFormUser = true
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-edit bg-white mr-2"
  }), _vm._v(" "), _c('span', [_vm._v("Modifier mon profil")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFormUser),
      expression: "showFormUser"
    }],
    staticClass: "fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
  }, [_c('div', {
    staticClass: "relative space-y-4 max-w-[350px] w-[90%] mx-auto bg-white rounded-lg p-6 text-center shadow-xl"
  }, [_c('button', {
    staticClass: "absolute top-3 right-3 bg-alert transition w-6 h-6 rounded-full flex items-center justify-center",
    on: {
      "click": function($event) {
        _vm.showFormUser = false
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-close bg-white"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "text-lg font-medium mb-5 uppercase text-secondary"
  }, [_vm._v("Modifier mes informations")]), _vm._v(" "), _c('div', {
    staticClass: "flex gap-2 justify-center"
  }, [_c('a', {
    staticClass: "btn-secondary",
    attrs: {
      "id": "photo-trigger",
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.triggerPhoto
    }
  }, [_vm._v("\n                                Photo\n                            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-vert",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n                                Signature\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('label', {
    staticClass: "block text-sm font-medium mb-1",
    attrs: {
      "for": "profil_client_phone_form"
    }
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('cleave', {
    ref: "telephone",
    staticClass: "w-full input px-3 py-2 border rounded-md",
    attrs: {
      "options": _vm.telOpt,
      "type": "text",
      "name": "numtel",
      "placeholder": "Téléphone",
      "id": "profil_client_phone_form",
      "inputmode": "tel"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.type !== 'magasinier'),
      expression: "user.type !== 'magasinier'"
    }],
    staticClass: "text-left",
    attrs: {
      "id": "display_immat"
    }
  }, [_c('label', {
    staticClass: "block text-sm font-medium mb-1",
    attrs: {
      "id": "profil_client_matricule_label",
      "for": "profil_client_matricule_form"
    }
  }, [_vm._v("\n                                Immatriculation\n                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.immatriculation),
      expression: "user.immatriculation"
    }],
    staticClass: "w-full input px-3 py-2 border rounded-md",
    attrs: {
      "type": "text",
      "name": "immat",
      "placeholder": "Immatriculation véhicule",
      "maxlength": "20",
      "id": "profil_client_matricule_form"
    },
    domProps: {
      "value": (_vm.user.immatriculation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "immatriculation", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "warning-info text-alert uppercase"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-primary inline-block px-4 py-2 rounded-md bg-primary text-white",
    attrs: {
      "id": "profil_client_submit_form",
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.saveInfos
    }
  }, [_vm._v("\n                            SAUVEGARDER\n                        ")])])]), _vm._v(" "), (_vm.user.type !== 'magasinier' && _vm.user.attestation_aptitude) ? _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "display_attestation"
    }
  }, [_c('hr', {
    staticClass: "border-gray-300 mx-auto"
  }), _vm._v(" "), _c('p', {
    staticClass: "text-md md:text-xl mt-4"
  }, [_vm._v("Attestation d'aptitude")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center gap-2 mb-4"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-security bg-secondary"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md md:text-xl font-bold text-secondary",
    attrs: {
      "id": "profil_client_attestation"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.user.attestation_aptitude) + "\n                        ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 flex flex-col items-center space-y-6 mb-40"
  }, [_c('button', {
    staticClass: "inline-flex items-center px-4 py-2 bg-success text-white font-semibold rounded-lg shadow text-md",
    attrs: {
      "id": "profil_client_send_data"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askSendData($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-support bg-white mr-2"
  }), _vm._v("\n                    Envoyer mes données au support\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "inline-flex items-center px-4 py-2 bg-white text-orange font-semibold rounded-lg shadow text-md",
    attrs: {
      "id": "profil_client_help",
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('help')
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-question bg-orange mr-2"
  }), _vm._v("\n                    Aide & tutoriels\n                ")]), _vm._v(" "), (this.user.operator && this.user.operator.id === 5) ? _c('a', {
    staticClass: "items-center px-4 py-2 bg-white text-alert font-semibold rounded-lg shadow text-md",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askDeleteDonnee($event)
      }
    }
  }, [_vm._v("\n                    DEBUG : Supprimer les données\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isDemo === true) ? _c('button', {
    staticClass: "items-center px-4 py-2 bg-white text-alert font-semibold rounded-lg shadow text-md",
    attrs: {
      "id": "profil_client_delete"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.askDeleteData($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-trash bg-alert mr-2"
  }), _vm._v("\n                    Supprimer mes données\n                ")]) : _vm._e()])])]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "signature": _vm.user.signature64
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "signatureUpdated": _vm.updateSignature
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "change-pdp hidden",
    attrs: {
      "method": "post"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "change-photo-profil"
    }
  })]), _vm._v(" "), _c('input', {
    ref: "photoInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "photo-profil"
    },
    on: {
      "change": _vm.updatePhoto
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "hidden",
    attrs: {
      "id": "prev-photo-profil"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddb90ebe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Profil.vue
// module id = 1056
// module chunks = 0